<template>
    <transition :name="transitionName">
        <slot />
    </transition>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "TransitionComponent",
        computed: {
            ...mapGetters({
                transitionName: "app-theme/transitionName",
                cachedRoutes: "app-theme/cachedRoutes",
                cachedRoutesHistory: "app-theme/cachedRoutesHistory"
            })
        }
    }
</script>

<style lang="scss" scoped>
    .slide-right-enter-active, .slide-left-enter-active, .slide-right-leave-active, .slide-left-leave-active {
        will-change: transform;
        transition: all 0.5s ease-out;
        position: absolute;
        overflow-y: auto;
    }

    .slide-right-enter {
        opacity: 0;
        transform: translate3d(-100%, 0, 0);
    }

    .slide-right-leave-active {
        opacity: 0;
        transform: translate3d(100%, 0, 0);
    }

    .slide-left-enter {
        opacity: 0;
        transform: translate3d(100%, 0, 0);
    }

    .slide-left-leave-active {
        opacity: 0;
        transform: translate3d(-100%, 0, 0);
    }
</style>
